// Unified signal constants combining review and company signals.
// Categories match the methodology structure in m2.json.
export const VALID_BBB_GRADES = new Set([
  "A+",
  "A",
  "A-",
  "B+",
  "B",
  "B-",
  "C+",
  "C",
  "C-",
  "D+",
  "D",
  "D-",
  "F",
])

export enum Signal {
  // Review signals (credibility)
  SUBSTANCE = "substance",
  RECENCY = "recency",
  FAIRNESS = "fairness",
  // Review signals (authority)
  STATUS = "status",
  TENURE = "tenure",
  SCOPE = "scope",
  // Company signals (work quality)
  SALES_CONDUCT = "sales_conduct",
  WORKMANSHIP = "workmanship",
  VALUE = "value",
  POST_SALE_SUPPORT = "post_sale_support",
  PROJECT_MANAGEMENT = "project_management",
  // Company signals (character)
  TRACK_RECORD = "track_record",
  VALID_LICENSE = "valid_license",
  BBB = "bbb",
  CLUSTERING = "clustering",
  GLOBAL_DUPLICATE = "global_duplicate",
  DECEPTION = "deception",
  LIEN = "lien",
  STRANDED = "stranded",
}
